import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StrategyEventFailedAction, StrategyEventLoadingAction, StrategyEventPendingAction, StrategyEventSuccessAction } from './actions';
import { initialStrategyEventState, StrategyEventState } from './state';

const strategyEventSlice = createSlice({
  name: 'strategy-event',
  initialState: initialStrategyEventState,
  reducers: {
    reset: () => initialStrategyEventState,
    loading: (state: StrategyEventState, action: PayloadAction<StrategyEventLoadingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: action.payload.loading,
        loaded: !action.payload.loading,
        pending: false,
        strategyEvents: state[action.payload.strategyId]?.strategyEvents ?? []
      };
    },
    pending: (state: StrategyEventState, action: PayloadAction<StrategyEventPendingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: false,
        pending: action.payload.pending,
        strategyEvents: state[action.payload.strategyId]?.strategyEvents ?? []
      };
    },
    success: (state: StrategyEventState, action: PayloadAction<StrategyEventSuccessAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: true,
        pending: false,
        strategyEvents: action.payload.strategyEvents
      };
    },
    fail: (state: StrategyEventState, action: PayloadAction<StrategyEventFailedAction>) => {
      state[action.payload.strategyId] = {
        error: action.payload.error,
        loading: false,
        loaded: true,
        pending: false,
        strategyEvents: state[action.payload.strategyId]?.strategyEvents ?? []
      };
    }
  }
});

const { actions, reducer } = strategyEventSlice;
export const { reset, loading, success, fail, pending } = actions;
export default reducer;
